<template>
  <div class="slideout">
    <div class="slideout-link">
      <div class="slideout-link-item active">
        <a href="https://www.getty.edu">
          Home
        </a>
        <b-button @click="closeSlideout">
          <b-icon icon="close" />
        </b-button>
      </div>
      <SlideoutNav :info="this.info" />
      <SlideoutForm :open="localIsOpen" />
      <div class="slideout-link-item">
        <a href="https://www.getty.edu/search/?hp-mobile-nav=1">
          MORE WAYS TO SEARCH
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import SlideoutForm from "@/components/SlideoutForm";
import SlideoutNav from "@/components/SlideoutNav";

export default {
  name: "Slideout",
  data() {
    return {
      localIsOpen: false,
      toggled: false
    };
  },
  components: {
    SlideoutForm,
    SlideoutNav
  },
  props: {
    info: Array,
    isOpen: Boolean
  },
  watch: {
    isOpen(newVal) {
      this.localIsOpen = newVal;
    }
  },
  methods: {
    closeSlideout() {
      this.localIsOpen = false;
      this.$emit("update:close:menu");
    }
  }
};
</script>
